__turbopack_context__.v({
  "ctaBanner": "mQzQ1q_ctaBanner",
  "ctaBannerBg": "mQzQ1q_ctaBannerBg",
  "ctaButton": "mQzQ1q_ctaButton",
  "ctaContent": "mQzQ1q_ctaContent",
  "ctaTitle": "mQzQ1q_ctaTitle",
  "footerSection": "mQzQ1q_footerSection",
  "footerText": "mQzQ1q_footerText",
});
